import { useState } from "react";
import '../css/cseDeptStyle.css';
const HindiPage = () => {
    return (
        <><div className="dept-wrapper">
            <div className="container">
                <section className="py-4 header">
                    <header>
                        {/* <img
                            src="https://nitw.ac.in/api/static/files/ciks_2025-4-2-17-6-30.jpg" className="img-fluid" /> */}
                        <center><h2>Hindi Cell</h2></center>
                    </header>
                    <div className="row">

                        <div className="col-md-2">
                            <div className="head_of_dept"> <a href="#"
                                target="_blank"> <img src="https://nitw.ac.in/api/static/files/Director_image1_2023-5-20-12-32-22.jpg" alt="" className="img-fluid" width="240" height="200" />
                            </a>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <br />
                            <b className="justified-text">नाम/Name - प्रोफेसर बिद्याधर सुबुधि/Prof. Bidyadhar Subudhi <br />
                                पद/Designation – निदेशक/Director <br />

                                ईमेल/Email – director@nitw.ac.in<br />

                                दूरभाष/Phone – 0870 246 2000

                            </b>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col-md-2">
                            <div className="head_of_dept"> <a href="#"
                                target="_blank"> <img src="https://nitw.ac.in/api/static/files/registrar_2025-4-11-19-36-22.png" alt="" className="img-fluid" width="240" height="200" />
                            </a>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <br />
                            <b className="justified-text">नाम/Name - श्री सुनील कुमार मेहता/ Shri Sunil Kumar Mehta <br />
                                पद/Designation – कुलसचिव/Registrar <br />

                                ईमेल/Email – registrar@nitw.ac.in<br />

                                दूरभाष/Phone – 0870 246 2010

                            </b>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="row">

                                <div className="col-md-4">
                                    <div className="head_of_dept"> <a href="#"
                                        target="_blank"> <img src="https://nitw.ac.in/api/static/files/Adesh_Srivastava_2023-10-18-12-18-51.jpg" alt="" className="img-fluid" width="240" height="200" />
                                    </a>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <br />
                                    <b className="justified-text">श्री आदेश श्रीवास्तव/Shri Adesh Srivastava<br />
                                        सहायक कुलसचिव (एसआरआईसी)/Assistant Registrar (SRIC)/
                                        राजभाषा अधिकारी /Hindi Officer/
                                        प्रशासनिक अधिकारी (एनआईटीडब्ल्यूआईईएफ)/Administrative Officer NITWIEF <br />

                                        hindiofficer@nitw.ac.in, adeshs@nitw.ac.in, ar_sric@nitw.ac.in<br />

                                        0870 246 4268

                                    </b>
                                </div>

                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="row">

                                <div className="col-md-4">
                                    <div className="head_of_dept"> <a href="#"
                                        target="_blank"> <img src="https://nitw.ac.in/api/static/files/Nitin_Raj_2025-4-22-17-33-52.jpg" alt="" className="img-fluid" width="240" height="200" />
                                    </a>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <br />
                                    <b className="justified-text">श्री नितिन राज/Shri Nitin Raj<br />
                                        कनिष्ठ सहायक (आंतरिक लेखा परीक्षा)/Junior Assistant (Internal Audit)/
                                        कनिष्ठ सहायक (राजभाषा प्रकोष्ठ)/Junior Assistant (Hindi Cell)
                                        <br />

                                        nitinr@nitw.ac.in<br />

                                        0870 246 2066

                                    </b>
                                </div>

                            </div>

                        </div>

                    </div>
                    <br/><br/>
                    <div>
                        <h3 style={{color:"#2b4675"}}>Resources / संसाधन</h3>
                        <div className="listview">
                                        <p className="listitem">
                         <a href="https://rajbhasha.gov.in/">Department of Official Language, Ministry of Home Affairs /राजभाषा विभाग, गृह मंत्रालय</a></p>
                         <p className="listitem"> <a href="https://hindishabdsindhu.rajbhasha.gov.in/">Hindi word Sindhu/हिंदी शब्द सिंधु</a></p>
                         <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/annual-programme-and-reports">	Annual Events & Reports/वार्षिक कार्यक्रम एवं रिपोर्ट</a></p>
                        </div>
                        <h3 style={{color:"#2b4675"}}>Official Language Provisions / राजभाषा संबंधी प्रावधान</h3>
                        <div className="listview">
                        <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/constitutional_provisions">Constitutional Provisions/संवैधानिक प्रावधान</a></p>
                        <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/official_languages_act_1963">Official Languages Act, 1963/राजभाषा अधिनियम, 1963</a></p>
                        <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/president_orders">Presidential Orders, 1960/राष्ट्रपति के आदेश, 1960</a></p>
                        <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/OL_resolution_1968">Official Language Resolution 1968/राजभाषा संकल्प 1968</a></p>
                        <p className="listitem"> <a href="https://rajbhasha.gov.in/hi/ol_rules_1976">Official Language Rules, 1976/राजभाषा नियम, 1976</a></p>
                        </div>
                    </div>



                </section>
            </div>
        </div>

        </>
    );
}
export default HindiPage;